import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authServices } from '../services/auth.service';
import toast from 'react-hot-toast';

export const useProfileUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authServices.updateProfile,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['user-profile']);
      toast.success(data?.message);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update user profile');
    },
  });
};
